export default "__VITE_ASSET__DzmT4IPu__"